import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('WelcomeApp => ');

const onWelcomeRedirectRequest = createAction('redirect request');
const onWelcomeRedirectSuccess = createAction('redirect request Success');
const onWelcomeRedirectFailure = createAction('redirect request Failure');

export default {
  onWelcomeRedirectRequest,
  onWelcomeRedirectSuccess,
  onWelcomeRedirectFailure,
};
